import React from "react";
// @ts-ignore
import "./AboutSection.css";

export default function AboutSection(): JSX.Element {
  return (
    <section className="about-section py-5" id="about">
      <div className="container">
        <div className="row align-items-center g-4">
          <div className="col-lg-5 gs-anim">
            <div className="about-img-wrap">
              <img
                src={`${process.env.PUBLIC_URL}/images/about-banner-480.webp`}
                srcSet={`${process.env.PUBLIC_URL}/images/about-banner-480.webp 480w, ${process.env.PUBLIC_URL}/images/about-banner-640.webp 640w, ${process.env.PUBLIC_URL}/images/about-banner-700.webp 700w, ${process.env.PUBLIC_URL}/images/about-banner-840.webp 840w`}
                sizes="(min-width: 992px) 460px, calc(100vw - 40px)"
                alt="GS Limo Elite luxury transportation service"
                title="GS Limo Elite luxury transportation service"
                className="about-img"
                width="1408"
                height="768"
                loading="lazy"
              />
            </div>
          </div>
          <div className="col-lg-7 gs-anim">
            <span className="section-badge">About Us</span>
            <h2 className="section-title">The GS Limo Elite Story</h2>
            <p className="about-text">
              GS Limo Elite provides limo and black car service across South
              Jersey and the surrounding area. The team focuses on clear
              communication, careful planning, and helping customers reach their
              destination.
            </p>
            <p className="about-text">
              Tell us your pickup, destination, timing, and seating needs when
              you request an estimate. We'll go over the route and current
              scheduling with you.
            </p>
            <div className="about-points">
              <div className="about-point">
                <i className="fas fa-check-circle"></i>
                <span>Airport and event quotes</span>
              </div>
              <div className="about-point">
                <i className="fas fa-check-circle"></i>
                <span>Airport transfers to PHL, EWR & JFK</span>
              </div>
              <div className="about-point">
                <i className="fas fa-check-circle"></i>
                <span>Professional drivers and car choices</span>
              </div>
              <div className="about-point">
                <i className="fas fa-check-circle"></i>
                <span>Serving South Jersey & the greater tri-state area</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}